var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information-area"},[_c('h2',{staticClass:"title text-gray-800 font-semibold text-xl"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content mt-2"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }